export enum InternalEventType {
	YOLO_DISPLAYED = 'yoloDisplayed',
	YOLO_INITIALIZED = 'yoloInitialized',
	YOLO_DISMISSED = 'yoloDismissed',
	FACEBOOK_INITIALIZED = 'facebookInitialized',
	OPEN_ID_PERMISSIONS_DISMISSED = 'openIdPermissionsDismissed',
	OPEN_ID_PERMISSIONS_ACCEPTED = 'openIdPermissionsAccepted',
	YOLO_NOT_DISPLAYED = 'yoloNotDisplayed',
}
